import { Flex } from "@chakra-ui/react"

import {
  selectDepositActionMigrationStatus,
  selectDepositActionStatus,
  selectDepositActionToken,
  selectDepositActionUserAmount,
  useDappSelector,
} from "#/redux-state"
import TokenLabel from "#/shared/components/TokenLabel"
import { useLockModalMats } from "#/shared/hooks"
import { DepositMigrationStatus } from "#/shared/types"
import { getTokenIcon } from "#/shared/utils"

import MatsDisplayWidget from "../MatsDisplayWidget"

export default function BoostModalHeader() {
  const userAmount = useDappSelector(selectDepositActionUserAmount)
  const token = useDappSelector(selectDepositActionToken)
  const lockStatus = useDappSelector(selectDepositActionStatus)
  const migrationStatus = useDappSelector(selectDepositActionMigrationStatus)

  const { dailyMats, newDailyMats } = useLockModalMats()

  if (!token) return null

  const tokenIcon = getTokenIcon(token)

  return (
    <Flex
      w="100%"
      justifyContent="space-between"
      alignItems="center"
      gap={4}
      mb={8}
    >
      <TokenLabel
        token={token}
        tokenIcon={tokenIcon}
        amount={userAmount}
        variant="large"
        isMigratedToTbtc={migrationStatus === DepositMigrationStatus.Completed}
      />
      <MatsDisplayWidget
        mats={lockStatus === "completed" ? newDailyMats : dailyMats}
        tooltipPlacement="left"
      />
    </Flex>
  )
}
